export class GlobalConstants {
  public static MOBILE_WIDTH_BREAKPOINT = 992;
  public static MOBILE_FOOTER_CHANGE_BREAKPOINT = 768;
  public static UPLOAD_FILE_LIMIT = 31457280;
  public static FHDomains = ['app', 'girteka']
}
